module.exports = __webpack_public_path__ + "static/media/ENDataTransparent.ec2d7a56.png";